import { type ChangeEvent } from 'react'
import { VpSearch } from '@vtmn-play/react/VpSearch'
import { useTranslation } from 'react-i18next'

type SearchBarProps = {
  label: string
  value: string
  onChange: (v: string) => void
}

export const SearchBar = ({ value, onChange, label }: SearchBarProps) => {
  const { t } = useTranslation('common')
  return (
    <VpSearch
      id="search"
      aria-label="search bar"
      placeholder={t(label)}
      data-testid="search-input"
      value={value}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      className="w-full h-12 rounded-full bg-neutral-100"
    />
  )
}
